import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
export function getSectionProgress(sectionContent) {
  // Ensure all sections are removed from the content
  var filteredContent = sectionContent.filter(function (content) {
    return content.type !== 'section';
  });
  var requiredItems = filteredContent.filter(function (item) {
    return !item.optional;
  });
  var countCompleted = requiredItems.filter(function (item) {
    return 'userContentStatus' in item && item.userContentStatus === 'completed';
  }).length;
  var countItems = requiredItems.length;

  // calculate the overall progress of the section
  var progress = countCompleted / countItems;
  if (progress === 1) {
    return {
      value: progress,
      status: 'completed'
    };
  }
  var isItemOpened = filteredContent.some(function (item) {
    return 'userContentStatus' in item && item.userContentStatus === 'opened';
  });
  if (progress > 0 || isItemOpened) {
    return {
      value: progress,
      status: 'opened'
    };
  }
  return {
    value: progress,
    status: 'notstarted'
  };
}